import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { GlobalState } from '../../../../../../store/types';
import { setBadgeCount, markAllMessagesRead } from '../../../../../../store/actions';

import Loader from './components/Loader';
import MessageItem from './MessageItem';
//import "./styles.scss";

type Props = {
    showTimeStamp: boolean;
    profileAvatar?: string;
    profileClientAvatar?: string;
    loading: boolean;
};

function Messages({ profileAvatar, profileClientAvatar, showTimeStamp, loading }: Props) {
    const dispatch = useDispatch();
    const { messages, typing, showChat, badgeCount } = useSelector((state: GlobalState) => ({
        messages: state.messages.messages,
        badgeCount: state.messages.badgeCount,
        typing: state.behavior.messageLoader,
        showChat: state.behavior.showChat
    }));

    const messageRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        if (showChat && badgeCount) dispatch(markAllMessagesRead());
        else dispatch(setBadgeCount(messages.filter((message) => message.unread).length));
    }, [messages, badgeCount, showChat, messageRef]);


    // TODO: Fix this function or change to move the avatar to last message from response
    // const shouldRenderAvatar = (message: Message, index: number) => {
    //   const previousMessage = messages[index - 1];
    //   if (message.showAvatar && previousMessage.showAvatar) {
    //     dispatch(hideAvatar(index));
    //   }
    // }

    return (
        <div id="messages" className="rcw-messages-container">
            {!loading &&
                messages?.map((message, index) => (
                    <MessageItem {...{ message, profileAvatar, profileClientAvatar, showTimeStamp }} />
                ))}

            <Loader typing={typing} />
        </div>
    );
}

export default Messages;
